import React, { useState } from 'react';
import type { Meta, StoryObj } from '@storybook/react';
import { TextArea, TextAreaProps } from '../TextInput';
import { Button } from '../Button';

const meta: Meta<typeof TextArea> = {
  title: 'Components/TextArea',
  component: TextArea,
};

export default meta;
type Story = StoryObj<typeof TextArea>;

function TextAreaStory(props: Omit<TextAreaProps, 'onChange'>) {
  const [value, setValue] = useState('');

  return (
    <TextArea
      {...props}
      value={value}
      onChange={e => {
        setValue(e.currentTarget.value);
      }}
    />
  );
}

export const Default: Story = {
  args: {
    label: 'Description',
  },
  render: TextAreaStory,
};

/** Example of `TextArea` with a placeholder and without a label. */
export const Placeholder: Story = {
  args: {
    placeholder: 'Description',
  },
  render: TextAreaStory,
};

export const Rows: Story = {
  args: {
    label: 'Description',
    rows: 10,
  },
  render: TextAreaStory,
};

/** Example of deprecated `rightAddon` prop. */
export const Addon: Story = {
  args: {
    label: 'Description',
    rightAddon: <Button>Button</Button>,
  },
  render: TextAreaStory,
};
